/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EksempelDataTo } from '../models/eksempel-data-to';


/**
 * Eksempel-API
 */
@Injectable({
  providedIn: 'root',
})
export class EksempelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEksempelData
   */
  static readonly GetEksempelDataPath = '/eksempel/{orgnr}';

  /**
   * Eksempel-tjeneste for å hente ut data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEksempelData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEksempelData$Response(params: {
    orgnr: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<EksempelDataTo>> {

    const rb = new RequestBuilder(this.rootUrl, EksempelService.GetEksempelDataPath, 'get');
    if (params) {
      rb.path('orgnr', params.orgnr, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EksempelDataTo>;
      })
    );
  }

  /**
   * Eksempel-tjeneste for å hente ut data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEksempelData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEksempelData(params: {
    orgnr: string;
  },
  context?: HttpContext

): Observable<EksempelDataTo> {

    return this.getEksempelData$Response(params,context).pipe(
      map((r: StrictHttpResponse<EksempelDataTo>) => r.body as EksempelDataTo)
    );
  }

  /**
   * Path part for operation updateEksempelData
   */
  static readonly UpdateEksempelDataPath = '/eksempel/{orgnr}';

  /**
   * Eksempel-tjeneste for lagre data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEksempelData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEksempelData$Response(params: {
    orgnr: string;
    body: EksempelDataTo
  },
  context?: HttpContext

): Observable<StrictHttpResponse<EksempelDataTo>> {

    const rb = new RequestBuilder(this.rootUrl, EksempelService.UpdateEksempelDataPath, 'put');
    if (params) {
      rb.path('orgnr', params.orgnr, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EksempelDataTo>;
      })
    );
  }

  /**
   * Eksempel-tjeneste for lagre data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEksempelData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEksempelData(params: {
    orgnr: string;
    body: EksempelDataTo
  },
  context?: HttpContext

): Observable<EksempelDataTo> {

    return this.updateEksempelData$Response(params,context).pipe(
      map((r: StrictHttpResponse<EksempelDataTo>) => r.body as EksempelDataTo)
    );
  }

  /**
   * Path part for operation getEksempelError
   */
  static readonly GetEksempelErrorPath = '/eksempel/error';

  /**
   * Eksempel-tjeneste som feiler for å vise klientlogger-funksjonalitet
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEksempelError()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEksempelError$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<EksempelDataTo>> {

    const rb = new RequestBuilder(this.rootUrl, EksempelService.GetEksempelErrorPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EksempelDataTo>;
      })
    );
  }

  /**
   * Eksempel-tjeneste som feiler for å vise klientlogger-funksjonalitet
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEksempelError$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEksempelError(params?: {
  },
  context?: HttpContext

): Observable<EksempelDataTo> {

    return this.getEksempelError$Response(params,context).pipe(
      map((r: StrictHttpResponse<EksempelDataTo>) => r.body as EksempelDataTo)
    );
  }

}
